import { render, staticRenderFns } from "./Thank.vue?vue&type=template&id=3f6c93e2&"
import script from "./Thank.vue?vue&type=script&lang=js&"
export * from "./Thank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports